<template>
  <div
    :class="conteudoClasses"
    style="position: relative"
  >
    <chat-log-item-conteudo-texto-icone
      :conteudo-texto="conteudoTexto"
      :mensagem-icon="mensagemIcon"
      :is-mensagem-do-atendente="isMensagemDoAtendente"
      :pode-responder-mensagem="podeResponderMensagem"
      :ticket-esta-finalizado="ticketEstaFinalizado"
    />

    <chat-log-item-conteudo-menu
      v-if="podeResponderMensagem && !ticketEstaFinalizado"
      :is-mensagem-do-atendente="isMensagemDoAtendente"
      @mensagem-selecionada-para-resposta="$emit('mensagem-selecionada-para-resposta')"
    />
  </div>
</template>

<style lang="scss">
@import '@core/preset/preset/apps/chat.scss';
</style>

<script>
import { ref, computed } from '@vue/composition-api'
import { mdiWhatsapp, mdiEmailOutline, mdiFileEditOutline, mdiGestureTapButton, mdiFacebookMessenger } from '@mdi/js'
import ChatLogItemConteudoTextoIcone from './ChatLogItemConteudoTextoIcone.vue'
import ChatLogItemConteudoMenu from './ChatLogItemConteudoMenu.vue'
import TiposDeCanaisEnum from '@/models/entities/canal/TiposDeCanaisEnum'
import ChatBotProvedorComunicacaoEnum from '@/models/entities/canal/ChatBotProvedorComunicacaoEnum'

export default {
  emits: ['mensagem-selecionada-para-resposta'],

  components: {
    ChatLogItemConteudoTextoIcone,
    ChatLogItemConteudoMenu,
  },

  props: {
    canalTipoId: {
      type: Number,
      required: true,
    },
    chatBotProvedorComunicacaoId: {
      type: Number,
      default: null,
    },
    conteudoTexto: {
      type: String,
      required: true,
    },
    isMensagemDoAtendente: {
      type: Boolean,
      required: true,
    },
    podeResponderMensagem: {
      type: Boolean,
      required: true,
    },
    ticketEstaFinalizado: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const isDialogOpen = ref(false)

    const conteudoClasses = computed(() => `
      chat-content pt-5 pb-3 px-4 elevation-1
      ${props.isMensagemDoAtendente ? 'primary white--text' : 'bg-card'}
    `)

    const mensagemIcon = computed(() => {
      const { canalTipoId, chatBotProvedorComunicacaoId } = props

      switch (canalTipoId) {
        case TiposDeCanaisEnum.AberturaManual: {
          return mdiFileEditOutline
        }
        case TiposDeCanaisEnum.Autoatendimento: {
          return mdiGestureTapButton
        }
        case TiposDeCanaisEnum.Email: {
          return mdiEmailOutline
        }
        case TiposDeCanaisEnum.WhatsApp: {
          return mdiWhatsapp
        }
        case TiposDeCanaisEnum.MetaMessenger: {
          return mdiFacebookMessenger
        }
        case TiposDeCanaisEnum.Bot: {
          if (chatBotProvedorComunicacaoId === ChatBotProvedorComunicacaoEnum.WhatsApp) {
            return mdiWhatsapp
          }

          if (chatBotProvedorComunicacaoId === ChatBotProvedorComunicacaoEnum.MetaMessenger) {
            return mdiFacebookMessenger
          }

          return null
        }
        default: {
          return null
        }
      }
    })

    return {
      isDialogOpen,
      conteudoClasses,
      mensagemIcon,
    }
  },
}
</script>
